




import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import DefinitionsAPI from "@/services/definitions";
import RecordForm from "./Components/DefinitionForm.vue";
import Definition from "@/models/definition";

@Component({
  components: { RecordForm },
})
export default class NewDefinition extends Vue {
  async save(model: Definition): Promise<void> {
    LayoutModule.showLoader();
    try {
      const r = await DefinitionsAPI.new(model);
      LayoutModule.setAlerts({
        text: this.$t("definitions.responses.success_create").toString(),
        type: "success",
      });
      this.$router.push({
        name: "editDefinition",
        params: { id: r?.id as string },
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "definitions" });
  }
}
